import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=a33b5854&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=a33b5854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33b5854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a33b5854')) {
      api.createRecord('a33b5854', component.options)
    } else {
      api.reload('a33b5854', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=a33b5854&scoped=true&", function () {
      api.rerender('a33b5854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZBWlCsU4sYtm/JS/comp/Voucher.vue"
export default component.exports